import { Action, AnyAction, Dispatch } from "redux";
import { clearChatMessages, loadChatMessages } from "../../../../store/actions/event/chat-actions";

export const cleanup = (dispatch: Dispatch<Action | AnyAction>) => () => {
	dispatch(clearChatMessages());
};

export const loadChatMessagesEffect = (
	dispatch: Dispatch<Action | AnyAction>,
	sessionUuid: string | undefined,
	isPreview: boolean,
	language: string
) => {
	if (sessionUuid && !isPreview) {
		dispatch(loadChatMessages(sessionUuid, language));
	}

	return cleanup(dispatch);
};